import moment from 'moment';
import _ from "underscore";
import sysMsgs from '@/helpers/system.message'
import formatCurrency from '@/helpers/utils'

import apiPayments from '@/services/finance.services'
import clientesServices from "@/services/dealers.services";

import Auth from "@/helpers/middleware";

  export default {
    name: "Orders",
    data() {
      return {
        loading: false,
        noResults: false,
        controller: {
          title: "Finanzas",
          mainRouter: "/finanzas/pagos"      
        },
        user: Auth.getUser(),
        comprobante: '',
        clients: [],
        clientstmp: [],
        searchQry: {
          client:{
            cod_cliente: null
          },
          order: null,
          estado: "all",
          comprobante: "all"
        },
        orders: [],
      };
    },
    filters:{
        currency(val){
          return formatCurrency.currency(val)
        },
        formatDateTime(val){
          return moment(val).format('DD-MM-YYYY, h:mm:ss a')
        }
    },
    watch: {
      'searchQry.client': {
        deep: true,
        handler(data) {
          if (data == null) {
            this.clean();
            return false;
          }
        }
      }
    },
    created() {
      this.getClients();
    },
    methods: {
      getClients(){
        clientesServices.general
        .getAll()
        .then(response => {
          this.clients = response.data.dealers;
          this.clientstmp = this.clients;
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
        });
      },
      setClientsList(search, loading) {
        if (search.toString().trim().length > 0) {
          this.clientstmp = _.filter(this.clients, filter => {
            return (
              filter.nombre_fantasia
                .toString()
                .toLowerCase()
                .indexOf(search.toString().toLowerCase()) > -1 ||
              filter.cod_cliente.toString() == search.toString()
            );
          });
        } else {
          this.clientstmp = this.clients;
        }
      },
      searchOrders() {
        this.loading = true;
        apiPayments.clients.getOrders(this.searchQry).then(response => {           
            this.orders = response.data.ordenes;
            this.loading = false;
            this.orders.length > 0 ? this.noResults = false : this.noResults = true
        }).catch(error => {
            sysMsgs.getResponseMessage(error.response);
            this.orders =[];
            this.loading = false;
        });
      },
      filterOrders(){
        //Ocultar ordenes con estado = 4 (eliminadas por usuario);
        return this.orders.filter(filter => filter.estado != 4);
      },
      updateOrder(order, status) {
        
        var label, type = "question";

        if(status == 1) { label = "Aprobar", order.transf_aprobador = this.user.email } else if ((status == 3))  { label = "Anular", type = "warning" } else {label = "Actualizar"}
        
        var disclaimer = status == 1 && order.url_comprobante == null ? " SIN COMPROBANTE " : ""

        sysMsgs.getConfirm(`¿Está seguro que quiere ${label}${disclaimer} la Orden Nro. ${order.id}?`, type)
        .then(result => {
          if (result.value) {
            var tmp = order.estado;
            order.estado = status;
            order.cod_op = order.id;
            this.loading = true;
            apiPayments.clients.setOrderStatus(order).then(response => {
              this.loading = false;
              if (response.codError && response.codError > 0) {
                order.estado = tmp;
                sysMsgs.getMessage("Ocurrió un error, reintenta nuevamente.", "error");
                return
              }
              this.orders.splice(this.orders.findIndex(item => item.id == order.id), 1, order);
              sysMsgs.getMessage(`Orden Nro. ${order.id} actualizada correctamente.`, "success");
            }).catch(error => {
                sysMsgs.getResponseMessage(error.response);
                this.loading = false;
            });
          }
        });
      },
      getEstado(val) {
        /*
        *  Dic. estados de Ordenes
        * 0-Pendiente, 1-Aprobado/Confirmado, 2-Anulado por cliente, 3-Anulado,  4- Eliminado
        */
        switch (parseInt(val)) {
          case 0:
            return '<i class="bg-info"></i> Pendiente'
          case 1:
            return '<i class="bg-success"></i> Aprobada'
          case 2:
            return '<i class="bg-warning"></i> Anulada por cliente'
          case 3:
            return '<i class="bg-danger"></i> Anulada'
          case 4:
            return '<i class="bg-danger"></i> Eliminada'
          default:
            return '<i class="bg-default"></i> No definido'
        }
      },
      orderReadyToApprove(order){
        return parseInt(order.tipo) == 2 && (parseInt(order.estado) == 0 || parseInt(order.estado) == 1) && order.url_comprobante != null
      },
      clean(){
        this.orders = [];
        this.noResults = false;
        this.searchQry = {
          client:{
            cod_cliente: null
          },
          order: null,
          estado: "all",
          comprobante: "all"
        }
      }
    }
  };